import React, { RefObject } from 'react'
import { isItemWithEan, isItemWithId, BaseItem } from '../types'

export type ProductItemRefManager = ReturnType<
  typeof createProductItemRefManager
>

export const createProductItemRefManager = () => {
  const itemsIdRef: Record<string, RefObject<HTMLDivElement>> = {}
  const itemsEanRef: Record<string, RefObject<HTMLDivElement>> = {}

  const allocItemRefs = (items: Item[]) => {
    items.forEach((item) => {
      const ref = React.createRef<HTMLDivElement>()
      if (isItemWithEan(item)) {
        itemsEanRef[item.ean] = ref
      }
      if (isItemWithId(item)) {
        itemsIdRef[item.id] = ref
      }
    })
  }

  const getItemRef = (item: BaseItem): Optional<RefObject<HTMLDivElement>> => {
    const eanRef = isItemWithEan(item) ? itemsEanRef[item.ean] : null
    const idRef = isItemWithId(item) ? itemsIdRef[item.id] : null
    return eanRef || idRef || null
  }

  return {
    getItemRef,
    allocItemRefs,
  }
}
